import { makeEnvironmentProviders } from '@angular/core';
import { AppInsightsConfig } from './app-insights-config';
import { AppInsightsInitializerProvider } from './app-insights-initializer.provider';

export function provideAppInsights<T extends object = object>(config?: AppInsightsConfig<T>) {
  return makeEnvironmentProviders([
    config ? { provide: AppInsightsConfig, useValue: config } : [],
    AppInsightsInitializerProvider
  ]);
}
